// https://developer.mozilla.org/en-US/docs/Web/API/Navigator/vendor

const isAppleComputerInc = () => {
  return navigator.vendor === 'Apple Computer, Inc.';
};

export default isAppleComputerInc;
